import React from 'react';
import styled, { css } from 'styled-components';
import { Field } from 'react-final-form';
import FormUtils from '~/components/organism/FormUtils';
import Checkbox from '~/components/molecule/Checkbox';
import { Heading4 } from '~/components/atom/Typography';

type Props = {
  $key: string;
  title: string;
  options: Array<{ label: string; name: string }>;
};

const CheckboxGroup: React.FCC<Props> = ({ $key, title, options }) => (
  <Container>
    <Heading4 size="m" margin={[null]}>
      {title}
    </Heading4>
    {options.map(item => (
      <Field key={`${$key}${item.name}-field`} name={item.name}>
        {({ input, meta: { error, touched } }) => {
          const { value, onChange } = input;
          return (
            <StyledCheckbox
              key={`${$key}${item.name}-checkbox`}
              onChange={() => onChange(!value)}
              value={value}
              label={item.label}
              name={item.name}
              error={FormUtils.showError(error, touched)}
            />
          );
        }}
      </Field>
    ))}
  </Container>
);

const Container = styled.div<{}>`
  width: 100%;

  ${({ theme }) => css`
    margin: ${theme.space('xxs')} 0;
  `}
`;

const StyledCheckbox = styled(Checkbox)<{}>`
  ${({ theme }) => css`
    margin: ${theme.space('s')} 0;
    font-size: ${theme.fontSize('base')};
  `}
`;

export default CheckboxGroup;
